/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { NameDto } from '../models/name-dto';
import { PaginatedDto } from '../models/paginated-dto';
import { reportControllerCreate } from '../fn/report/report-controller-create';
import { ReportControllerCreate$Params } from '../fn/report/report-controller-create';
import { reportControllerDelete } from '../fn/report/report-controller-delete';
import { ReportControllerDelete$Params } from '../fn/report/report-controller-delete';
import { reportControllerFindAll } from '../fn/report/report-controller-find-all';
import { ReportControllerFindAll$Params } from '../fn/report/report-controller-find-all';
import { reportControllerFindAllDropdown } from '../fn/report/report-controller-find-all-dropdown';
import { ReportControllerFindAllDropdown$Params } from '../fn/report/report-controller-find-all-dropdown';
import { reportControllerFindOne } from '../fn/report/report-controller-find-one';
import { ReportControllerFindOne$Params } from '../fn/report/report-controller-find-one';
import { reportControllerGetClientReports } from '../fn/report/report-controller-get-client-reports';
import { ReportControllerGetClientReports$Params } from '../fn/report/report-controller-get-client-reports';
import { reportControllerGetWordSummary } from '../fn/report/report-controller-get-word-summary';
import { ReportControllerGetWordSummary$Params } from '../fn/report/report-controller-get-word-summary';
import { reportControllerRestore } from '../fn/report/report-controller-restore';
import { ReportControllerRestore$Params } from '../fn/report/report-controller-restore';
import { reportControllerUpdate } from '../fn/report/report-controller-update';
import { ReportControllerUpdate$Params } from '../fn/report/report-controller-update';
import { reportControllerView } from '../fn/report/report-controller-view';
import { ReportControllerView$Params } from '../fn/report/report-controller-view';
import { ReportDto } from '../models/report-dto';
import { ReportEntryDto } from '../models/report-entry-dto';
import { ReportListItemDto } from '../models/report-list-item-dto';
import { ReportViewDto } from '../models/report-view-dto';

@Injectable({ providedIn: 'root' })
export class ReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportControllerFindAll()` */
  static readonly ReportControllerFindAllPath = '/api/report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAll$Response(params: ReportControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<ReportListItemDto>;
}>> {
    const obs = reportControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAll(params: ReportControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<ReportListItemDto>;
}> {
    const resp = this.reportControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<ReportListItemDto>;
}>): PaginatedDto & {
'items'?: Array<ReportListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `reportControllerCreate()` */
  static readonly ReportControllerCreatePath = '/api/report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportControllerCreate$Response(params: ReportControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    const obs = reportControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportControllerCreate(params: ReportControllerCreate$Params, context?: HttpContext): Observable<ReportDto> {
    const resp = this.reportControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportControllerUpdate()` */
  static readonly ReportControllerUpdatePath = '/api/report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportControllerUpdate$Response(params: ReportControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    const obs = reportControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportControllerUpdate(params: ReportControllerUpdate$Params, context?: HttpContext): Observable<ReportDto> {
    const resp = this.reportControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportControllerFindAllDropdown()` */
  static readonly ReportControllerFindAllDropdownPath = '/api/report/dropdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindAllDropdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAllDropdown$Response(params?: ReportControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
    const obs = reportControllerFindAllDropdown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindAllDropdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindAllDropdown(params?: ReportControllerFindAllDropdown$Params, context?: HttpContext): Observable<Array<NameDto>> {
    const resp = this.reportControllerFindAllDropdown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NameDto>>): Array<NameDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerFindOne()` */
  static readonly ReportControllerFindOnePath = '/api/report/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindOne$Response(params: ReportControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
    const obs = reportControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerFindOne(params: ReportControllerFindOne$Params, context?: HttpContext): Observable<ReportDto> {
    const resp = this.reportControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportDto>): ReportDto => r.body)
    );
  }

  /** Path part for operation `reportControllerDelete()` */
  static readonly ReportControllerDeletePath = '/api/report/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerDelete$Response(params: ReportControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerDelete(params: ReportControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportControllerRestore()` */
  static readonly ReportControllerRestorePath = '/api/report/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerRestore$Response(params: ReportControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerRestore(params: ReportControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportControllerGetClientReports()` */
  static readonly ReportControllerGetClientReportsPath = '/api/report/reports/{clientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerGetClientReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerGetClientReports$Response(params: ReportControllerGetClientReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportEntryDto>>> {
    const obs = reportControllerGetClientReports(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerGetClientReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerGetClientReports(params: ReportControllerGetClientReports$Params, context?: HttpContext): Observable<Array<ReportEntryDto>> {
    const resp = this.reportControllerGetClientReports$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReportEntryDto>>): Array<ReportEntryDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerView()` */
  static readonly ReportControllerViewPath = '/api/report/view';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerView()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerView$Response(params: ReportControllerView$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportViewDto>>> {
    const obs = reportControllerView(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerView(params: ReportControllerView$Params, context?: HttpContext): Observable<Array<ReportViewDto>> {
    const resp = this.reportControllerView$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReportViewDto>>): Array<ReportViewDto> => r.body)
    );
  }

  /** Path part for operation `reportControllerGetWordSummary()` */
  static readonly ReportControllerGetWordSummaryPath = '/api/report/word';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportControllerGetWordSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerGetWordSummary$Response(params: ReportControllerGetWordSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = reportControllerGetWordSummary(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportControllerGetWordSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportControllerGetWordSummary(params: ReportControllerGetWordSummary$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.reportControllerGetWordSummary$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
